import {UI} from "../../../../../stem-core/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {DonationAmountAndFrequency} from "./components/DonationAmountAndFrequency.jsx";
import {Flow} from "../../../flows/Flow.js";
import {styleRule} from "../../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


export class DonatePanelStyle extends BasePanelPageStyle {
    @styleRule
    button = {
        width: "100%",
        marginTop: 18,
    }
}

@registerStyle(DonatePanelStyle)
export class DonatePanel extends BasePanelPage {
    render() {
        return [
            <DonationAmountAndFrequency ref="donateComponent" onChange={() => this.redraw()}/>,
            <BlinkButton
                label={Flow.donationDetails.getDonateComponentButtonLabel()}
                disabled={!Flow.donationDetails.isValid()}
                onClick={() => this.donate()}
                className={this.styleSheet.button}/>,
        ];
    }

    donate() {
        // TODO @Mihai this doesn't match the other donation flow
        Flow.paymentMethod.showPanel();
    }
}
